import { makeVar, InMemoryCache } from "@apollo/client";
import { authGetAcc, authWrapper } from "../Auth/msauth";

export const userStatus = makeVar({
  loggedIn:false,
  name: null
});

export const phoneList = makeVar([
  {
    propertyID: 123,
    mobile: "0422135454",
    type: "residential",
    address: "40 Brennan St. Yagoona NSW 2199",
    name: "Beth Jones"
  },
  {
    propertyID: 124,
    mobile: "0422135454",
    type: "residential",
    address: "44 Brennan St. Yagoona NSW 2199",
    name: "Don Jones"
  },
  {
    propertyID: 125,
    mobile: "0422-135-454",
    type: "commericial",
    address: "40 Brennan St. Yagoona NSW 2199",
    name: "Beth Jones"
  },
  {
    propertyID: 126,
    mobile: "0422 135 454",
    type: "commericial",
    address: "44 Brennan St. Yagoona NSW 2199",
    name: "Don Jones"
  },
])

export const serviceRequests = makeVar([
  {
    id: "572489",
    type: "Missed Bin",
    created: "04/11/20",
    status: "pending"
  },
  {
    id: "187155",
    type: "Missed Bin",
    created: "31/10/20",
    status: "pending"
  },
  {
    id: "002893",
    type: "Damaged Bin",
    created: "10/01/20",
    status: "complete"
  },
  {
    id: "746335",
    type: "Dumped Rubbish",
    created: "14/02/18",
    status: "complete"
  },
])


export const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        userStatus: {
          read() {
            return userStatus();
          }
        },
        propertyList: {
          read() {
            return phoneList();
          }
        },
        serviceRequests: {
          read() {
            return serviceRequests();
          }
        },
        authData: {
          read() {
            return authWrapper().then(resp=>resp)
          }
        },
        accData: {
          read() {
            return authGetAcc()
          }
        }
      }
    }
  }
});